var assign = require("lodash/assign");

var isEmpty = require("lodash/isEmpty");

import { AggsContainer } from "./AggsContainer"; // Emulates the maximum value an integer can have in Java
// See: https://docs.oracle.com/javase/7/docs/api/java/lang/Integer.html#MAX_VALUE

export var DefaultNumberBuckets = Math.pow(2, 31) - 1;
export function TermsBucket(key, field) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  for (var _len = arguments.length, childAggs = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    childAggs[_key - 3] = arguments[_key];
  }

  return AggsContainer(key, {
    terms: assign({
      field: field
    }, options)
  }, childAggs);
}
export function RangeBucket(key, field, ranges) {
  for (var _len2 = arguments.length, childAggs = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
    childAggs[_key2 - 3] = arguments[_key2];
  }

  return AggsContainer(key, {
    range: {
      field: field,
      ranges: ranges
    }
  }, childAggs);
}
export function ChildrenBucket(key, type) {
  for (var _len3 = arguments.length, childAggs = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
    childAggs[_key3 - 2] = arguments[_key3];
  }

  return AggsContainer(key, {
    children: {
      type: type
    }
  }, childAggs);
}
export function FilterBucket(key, filter) {
  for (var _len4 = arguments.length, childAggs = new Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
    childAggs[_key4 - 2] = arguments[_key4];
  }

  if (isEmpty(filter)) {
    return AggsContainer(key, {
      filter: {
        match_all: {}
      }
    }, childAggs);
  }

  return AggsContainer(key, {
    filter: filter
  }, childAggs);
}
export function NestedBucket(key, path) {
  for (var _len5 = arguments.length, childAggs = new Array(_len5 > 2 ? _len5 - 2 : 0), _key5 = 2; _key5 < _len5; _key5++) {
    childAggs[_key5 - 2] = arguments[_key5];
  }

  return AggsContainer(key, {
    nested: {
      path: path
    }
  }, childAggs);
}
export function SignificantTermsBucket(key, field) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  for (var _len6 = arguments.length, childAggs = new Array(_len6 > 3 ? _len6 - 3 : 0), _key6 = 3; _key6 < _len6; _key6++) {
    childAggs[_key6 - 3] = arguments[_key6];
  }

  return AggsContainer(key, {
    significant_terms: assign({
      field: field
    }, options)
  }, childAggs);
}
export function GeohashBucket(key, field, options) {
  for (var _len7 = arguments.length, childAggs = new Array(_len7 > 3 ? _len7 - 3 : 0), _key7 = 3; _key7 < _len7; _key7++) {
    childAggs[_key7 - 3] = arguments[_key7];
  }

  return AggsContainer(key, {
    geohash_grid: assign({
      field: field
    }, options)
  }, childAggs);
}
export function HistogramBucket(key, field) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  for (var _len8 = arguments.length, childAggs = new Array(_len8 > 3 ? _len8 - 3 : 0), _key8 = 3; _key8 < _len8; _key8++) {
    childAggs[_key8 - 3] = arguments[_key8];
  }

  return AggsContainer(key, {
    histogram: assign({
      field: field
    }, options)
  }, childAggs);
}
export function GeoboundsBucket(key, field) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  for (var _len9 = arguments.length, childAggs = new Array(_len9 > 3 ? _len9 - 3 : 0), _key9 = 3; _key9 < _len9; _key9++) {
    childAggs[_key9 - 3] = arguments[_key9];
  }

  return AggsContainer(key, {
    geo_bounds: assign({
      field: field
    }, options)
  }, childAggs);
}
export function DateHistogramBucket(key, field) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  for (var _len10 = arguments.length, childAggs = new Array(_len10 > 3 ? _len10 - 3 : 0), _key10 = 3; _key10 < _len10; _key10++) {
    childAggs[_key10 - 3] = arguments[_key10];
  }

  return AggsContainer(key, {
    date_histogram: assign({
      field: field
    }, options)
  }, childAggs);
}